import React from "react";
import DashboardIcon from "@material-ui/icons/DashboardOutlined";
import PeopleIcon from "@material-ui/icons/PeopleOutline";
import InsertDriveFileOutlined from "@material-ui/icons/InsertDriveFileOutlined";
import AssignmentReturnOutlined from "@material-ui/icons/AssignmentReturnOutlined";

import TuneIcon from "@material-ui/icons/Tune";
import Home from "../pages/Home";
import List from "../pages/Invoices/List";
import AvoirList from "../pages/Avoirs/List";
import { List as SuppliersList } from "../pages/Suppliers/List";
import { UsersHome } from "../administration/users";
import Roles from "../redux/constants/roles";

export default {
	invoices: [
		{
			index: 1,
			name: "Dashboard",
			menuPermissionName: "Dashboard invoices",
			path: "/",
			component: () => <Home />,
			icon: <DashboardIcon />,
			hasAccess: [Roles.user, Roles.manager],
		},
		{
			index: 2,
			name: "Administration",
			menuPermissionName: "Administration",
			path: "/administration/invoice/commercial-organization",
			component: () => <UsersHome />,
			icon: <TuneIcon />,
			hasAccess: [Roles.admin],
		},
		{
			index: 3,
			name: "Invoices",
			menuPermissionName: "Invoices list",
			path: "/invoices",
			component: () => <List />,
			icon: <InsertDriveFileOutlined />,
			hasAccess: [Roles.user, Roles.manager],
		},
		{
			index: 4,
			// Clé i18n, comme toutes les autres entrées du menu — traduite dans les 5 langues.
			name: "Avoirs",
			menuPermissionName: "Invoices list",
			path: "/avoirs",
			component: () => <AvoirList />,
			// Document + flèche de retour : même famille visuelle que les factures, mais distinct d'elles
			// (l'entrée reprenait auparavant l'icône des factures, rendant les deux items indiscernables).
			icon: <AssignmentReturnOutlined />,
			hasAccess: [Roles.user, Roles.manager],
		},
		{
			index: 5,
			name: "Suppliers",
			menuPermissionName: "Suppliers",
			path: "/supplier",
			component: () => <SuppliersList />,
			icon: <PeopleIcon />,
			hasAccess: [Roles.user, Roles.manager],
		},
	],
};
